var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMspCopyTo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41674_99954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.67647 11.875C4.30971 11.875 3.19727 10.7626 3.19727 9.39584V3.41675H2.17647C1.29153 3.41675 0.572266 4.13591 0.572266 5.02084V12.8958C0.572266 13.7808 1.29153 14.5 2.17647 14.5H9.46806C10.353 14.5 11.0723 13.7808 11.0723 12.8958V11.875H5.67647Z",
    fill: "#C9CDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4056 2.1042C13.4056 1.21809 12.6875 0.5 11.8015 0.5H5.67647C4.79036 0.5 4.07227 1.21809 4.07227 2.1042V9.3958C4.07227 10.2819 4.79036 11 5.67647 11H11.8015C12.6875 11 13.4056 10.2819 13.4056 9.3958V2.1042Z",
    fill: "#C9CDD7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41674_99954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(-0.00195312 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMspCopyTo);
export default __webpack_public_path__ + "static/media/msp_copy_to.15038dc23a4f273eaa2e986571f3dadf.svg";
export { ForwardRef as ReactComponent };